import { Typography } from "@material-ui/core";
import moment from "moment";
import { DefaultCard } from "../../../../../components/cards/components";
import { TextFieldSaurus } from "../../../../../components/controles/inputs";
import { DispensacaoMedicamentoLoteCardProp } from "../../models/dispensacao-avulsa-props";
import { useStyles } from "./dispensacao-avulsa-medicamento-lotes-style";


export const DispensacaoMedicamentoLotesCard = (({ lote, alteraLoteQtd }: DispensacaoMedicamentoLoteCardProp) => {
  const styles = useStyles();

  return (
    <DefaultCard>
      <div className={`flex-row h-100 w-100 ${styles.cardContainer}`}>

        <div className={`h-100 ${styles.statusBarContainer}`}>
          <div className={`${styles.statusBarStyle}`} style={{
            backgroundColor: lote.quantidadeReservada ? 'var(--sistema-sucesso)' : 'var(--sistema-sem-acao)'
          }} />
        </div>

        <div className={`flex-row w-100 ${styles.infoContainer}`}>
          <div className="flex-column">
            <Typography className={styles.labelFont}>
              Lote
            </Typography>
            <Typography className={styles.contentFont}>
              {lote.lote}
            </Typography>
          </div>
          <div className="flex-column">
            <Typography className={styles.labelFont}>
              Validade
            </Typography>
            <Typography className={styles.contentFont}>
              {moment(lote.dataValidade).format("DD/MM/YYYY")}
            </Typography>
          </div>
          <div className="flex-column">
            <Typography className={styles.labelFont}>
              Disponível
            </Typography>
            <Typography className={styles.contentFont}>
              {lote.quantidade}
            </Typography>
          </div>
          <div>
            <TextFieldSaurus labelCustom="Qtd"
              value={lote.quantidadeReservada ?? 0}
              className={`h-100 w-100 ${styles.inputStyle}`}
              variant="outlined"
              size="small"
              tipo="NUMERO"
              onChange={(e: any) =>
                alteraLoteQtd(lote.lote, e.target.value > lote.quantidade
                  ? lote.quantidade
                  : Number(e.target.value))
              }
            />
          </div>
        </div>
      </div>
    </DefaultCard>
  );
});